export default (startValue: string, arr: string[]) => {
  const manchesterized = arr.map((string) => {
    const bitArray = string.split('');
    const parityArray = bitArray.map((bit) => (bit === '0' ? '10' : '01'));
    return `${startValue}${parityArray.join('')}`;
  });
  return manchesterized.join('');
};
